import { type ReactNode } from 'react';
import { Button, Icon } from '@ics-portal/guardian';
import { useMapContext } from '@pages/map/_utils/map-context';

export function ProjectDetailsActions(): ReactNode {
    const { project } = useMapContext();
    if (!project) {
        return null;
    }
    return (
        <div className="flex flex-column gap-4 align-items-center">
            <Button
                label="Go to project"
                to={`/projects/${project.id}`}
                iconPos="right"
                icon={<Icon name="arrow_right_alt" />}
            />
        </div>
    );
}
